import { Translation } from "@bimproject/t9n";

import Color from "./Color";
import SpecificationConfiguration from "./SpecificationConfiguration";

export default class Application {

    domain: string;

    name: string;

    about: Translation[];

    /**
     * ISO 3166-1 alpha-3 country code.
     */
    country: string;

    brandIDs: string[];

    colors: {
        accent: Color
        primary: Color
        secondary: Color
        tertiary: Color
    };

    favicon: string;

    logo: string;

    coverImage: string;

    instanceSpecification: SpecificationConfiguration;

    typeSpecification: SpecificationConfiguration;

    features: string[];

    constructor(brand: ApplicationStruct) {
        Object.assign(this, brand);
        Object.freeze(this);
    }

    change(change: ApplicationStruct) {
        return new (this.constructor as new (application: ApplicationStruct) => this)({ ...this, ...change });
    }

}

type Attributes<T> = {
    [K in keyof T]: T[K] extends (...args: never[]) => unknown ? never : K
}[keyof T];

type ApplicationAttributes = Attributes<Application>;
export type ApplicationStruct = Partial<Pick<Application, ApplicationAttributes>>;
